import PropTypes from 'prop-types';
import React from 'react';
import './SecondaryButton.sass';

const SecondaryButton = ({ style, animated, color, onClick, tabIndex, onTouchMove, children, className }) => {
	if (!style) style = {};

	if (animated) {
		const delay =
			Object.prototype.toString.call(animated) === '[object String]'
				? animated
				: '0s';
		style.transform = 'scale(0)';
		style.animation = `secondarybutton--animated 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) ${delay} both`;
	}

	if (color) {
		style.color = color;
	}

	return (
		<button
			className={`secondarybutton p-4 font-bold text-lg ${className}`}
			style={style}
			onTouchStart={() => {
				// @ts-ignore
				window.playSound(`button_${Math.floor(Math.random() * 4) + 1}`, 0.3);
			}}
			onTouchMove={onTouchMove}
			onTouchEnd={() => {
				// @ts-ignore
				window.vibrate();
			}}
			onClick={onClick}
			tabIndex={tabIndex}
			type="button">
			{children}
		</button>
	);
};

SecondaryButton.propTypes = {
	animated: PropTypes.any,
	children: PropTypes.any.isRequired,
	className: PropTypes.any,
	color: PropTypes.any,
	onClick: PropTypes.any,
	onTouchMove: PropTypes.any,
	style: PropTypes.any,
	tabIndex: PropTypes.any
}

SecondaryButton.defaultProps = {
	animated: undefined,
	className: undefined,
	color: undefined,
	onClick: undefined,
	onTouchMove: undefined,
	style: undefined,
	tabIndex: undefined,
}

export default SecondaryButton;
